export default "__VITE_ASSET__D1jU7YZ2__"